"use strict";

exports.__esModule = true;
exports.default = void 0;
var _consts = require("../consts");
const tooltipSize = ({
  size
}) => {
  const sizes = {
    [_consts.SIZE_OPTIONS.SMALL]: "240px",
    [_consts.SIZE_OPTIONS.MEDIUM]: "380px"
  };
  return sizes[size];
};
var _default = tooltipSize;
exports.default = _default;